
import { oz } from '@weft/utils';
import { MeasurementsStatsSchema } from './measurements-stats-schema';

export const GetMeasurementsStatsResponseSchema = oz.object({
  measurementsStats:  oz.array(MeasurementsStatsSchema),
}).openapi('GetMeasurementsStatsResponse');

export type GetMeasurementsStatsResponse = oz.infer<typeof GetMeasurementsStatsResponseSchema>;